import {getTestProps} from '@benchling/js-test-utils';
import {StyleSheet, css} from 'aphrodite';
import React from 'react';

import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {GRAY_DARKER, GRAY_SEMIDARK} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export function NoAccessChatListing({dataTestAttrs}: {dataTestAttrs: DataTestAttrs}): JSX.Element {
  return (
    <div className={css(styles.noAccessMessage)} {...getTestProps(dataTestAttrs)}>
      <div className={css(styles.noAccessMessageContent)}>
        <BenchlingIcon icon="lock" color={GRAY_DARKER} className={css(styles.noAccessIcon)} />
        <h3 className={css(styles.noAccessTitle)}>AI Chats Unavailable</h3>
        <p className={css(styles.noAccessDescription)}>
          You don't yet have access to AI chats. AI chats can help you find information in Benchling, create
          new items, and more.
        </p>
        <br />
        <p className={css(styles.noAccessDescription)}>
          Contact your administrator to enable this feature for your account.
        </p>
        <br />
        <p className={css(styles.noAccessDescription)}>
          If you are an administrator, you can find more information about enabling this feature at the{' '}
          <a
            href="https://help.benchling.com/hc/en-us/articles/25260337033741-AI-at-Benchling-overview"
            target="_blank"
            rel="noopener noreferrer"
          >
            AI at Benchling Overview
          </a>{' '}
          page.
        </p>
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  noAccessMessage: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    padding: '48px 24px',
  },
  noAccessMessageContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    maxWidth: '280px',
  },
  noAccessIcon: {
    fontSize: '32px',
    marginBottom: '16px',
  },
  noAccessTitle: {
    fontSize: '18px',
    fontWeight: 600,
    color: GRAY_DARKER,
    margin: 0,
    marginBottom: '8px',
  },
  noAccessDescription: {
    fontSize: '14px',
    lineHeight: '20px',
    color: GRAY_SEMIDARK,
    margin: 0,
  },
});
